import { contextApp } from 'context';
import { useLocation, useNavigate /* useParams */ } from 'react-router-dom';
import { toast } from 'react-toastify';

const useErrors = () => {
 const { pathname, state } = useLocation();
 const navigate = useNavigate();
 const { setAuth } = contextApp();

 /* useEffect(() => {
  if (!auth?.token) return navigate('/authentication/card/login', { state: { ...state, restorePage: pathname } });
 }, [auth]); */

 const setError = (err, redirect = true) => {
  const {
   response: { data, status }
  } = err;

  let msg = '';

  if (status === 400)
   msg = 'Esta respuesta significa que el servidor no pudo interpretar la solicitud dada una sintaxis inválida.';
  else if (status === 401)
   msg =
    'Es necesario autenticar para obtener la respuesta solicitada. Esta es similar a 403, pero en este caso, la autenticación es posible.';
  else if (status === 403)
   msg =
    'El cliente no posee los permisos necesarios para cierto contenido, por lo que el servidor está rechazando otorgar una respuesta apropiada.';
  else if (status === 404) msg = 'La petición estaba bien formada pero no se pudo encontrar ningun dato.';
  else if (status === 422) msg = 'La petición estaba bien formada pero no se pudo seguir debido a errores de semántica.';

  console.log({ ...data, status }, ' Error: ' + msg);

  if (status == 401) {
   setAuth(null);
   localStorage.removeItem('sesion');
   if (redirect) return navigate('/authentication/card/login', { state: { ...state, restorePage: pathname } });
  }
  return toast.error(data.message ?? msg);
 };

 return { setError };
};

export default useErrors;
